export const MAPPING_CATEGORIES = {
  required: {
    title: "Champs requis",
    description: "Tous ces champs doivent être mappés",
    bgColor: "bg-red-50 dark:bg-red-900/20",
    borderColor: "border-red-200 dark:border-red-800",
    titleColor: "text-red-800 dark:text-red-400"
  },
  important: {
    title: "Champs importants",
    description: "Au moins un des champs doit être mappé",
    bgColor: "bg-orange-50 dark:bg-orange-900/20",
    borderColor: "border-orange-200 dark:border-orange-800",
    titleColor: "text-orange-800 dark:text-orange-400"
  },
  optional: {
    title: "Champs optionnels",
    description: "Mapping facultatif aidant grandement à la qualité des données",
    bgColor: "bg-gray-50 dark:bg-gray-800",
    borderColor: "border-gray-200 dark:border-gray-700",
    titleColor: "text-gray-800 dark:text-gray-400"
  }
};